import { render, staticRenderFns } from "./makes-item-popular.vue?vue&type=template&id=74f2a1b2"
import script from "./makes-item-popular.vue?vue&type=script&lang=js"
export * from "./makes-item-popular.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports